import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Button, Card, CardBody, CardHeader, Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import * as receiptActions from '../../actions/receiptActions';

const formatDateTime = (value) => (value ? moment(value).format('DD-MM-YYYY LT') : '');
const formatLitres = (value) => (value || value === 0 ? `${value}L` : '');

// Compact list of the truck's receipts relevant to this run (assigned-to-this-run + unassigned).
// Deliberately minimal — date/time, volume, view receipt only (no lat/long, per requirements).
class RunReceiptsList extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            viewOpen: false,
            viewReceipt: null,
        };
        this.openView = this.openView.bind(this);
        this.closeView = this.closeView.bind(this);
    }

    componentDidMount() {
        if (this.props.runId && this.props.runReceipts.runId !== this.props.runId) {
            this.props.actions.loadRunReceipts(this.props.runId);
        }
    }

    componentDidUpdate(prevProps) {
        // A new receipt arrived over SignalR (truckData.receipt updated) — refresh the run's receipts
        // so the list reflects it live.
        const prevId = prevProps.truckData && prevProps.truckData.receipt && prevProps.truckData.receipt.receiptId;
        const curId = this.props.truckData && this.props.truckData.receipt && this.props.truckData.receipt.receiptId;
        if (this.props.runId && curId && curId !== prevId) {
            this.props.actions.loadRunReceipts(this.props.runId);
        }
    }

    openView(receipt) {
        this.setState({ viewOpen: true, viewReceipt: receipt || null });
    }

    closeView() {
        this.setState({ viewOpen: false, viewReceipt: null });
    }

    render() {
        const { runReceipts, runId } = this.props;
        const { viewOpen, viewReceipt } = this.state;
        const items = (runReceipts && runReceipts.runId === runId && Array.isArray(runReceipts.items))
            ? runReceipts.items : [];

        return (
            <Card className="mt-3">
                <CardHeader><i className="fa fa-file-text-o" /> Truck Receipts</CardHeader>
                <CardBody>
                    {items.length === 0 &&
                        <p className="text-muted mb-0">No receipts for this truck.</p>}
                    {items.length > 0 &&
                        <Table striped responsive className="mb-0">
                            <thead>
                                <tr>
                                    <th>Tank #</th>
                                    <th>Received</th>
                                    <th>Type</th>
                                    <th>Volume</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {items.map((r) => (
                                    <tr key={r.id} className={r.tankId ? '' : 'text-muted'}>
                                        <td>{r.tankId ? `#${r.tankId}` : ''}</td>
                                        <td>{formatDateTime(r.receivedAt)}</td>
                                        <td>{r.type === 'Collection' ? 'Collection' : 'Delivery'}</td>
                                        <td>{formatLitres(r.litres != null ? r.litres : r.deliveryTotal)}</td>
                                        <td>
                                            <Button color="link" className="p-0"
                                                    onClick={() => this.openView(r)}>
                                                <i className="fa fa-file-text-o" /> View receipt
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>}
                </CardBody>

                <Modal isOpen={viewOpen} toggle={this.closeView} size="lg">
                    <ModalHeader toggle={this.closeView}>Receipt</ModalHeader>
                    <ModalBody>
                        {viewReceipt && viewReceipt.address &&
                            <p className="mb-2"><strong>Location:</strong> {viewReceipt.address}</p>}
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginBottom: 0 }}>{viewReceipt && viewReceipt.emailContent}</pre>
                        <div className="mt-2 text-right">
                            <Button color="secondary" onClick={this.closeView}>Close</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </Card>
        );
    }
}

RunReceiptsList.propTypes = {
    runId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    runReceipts: PropTypes.object,
    truckData: PropTypes.object,
    actions: PropTypes.object,
};

function mapStateToProps(state) {
    return { runReceipts: state.runReceipts, truckData: state.truckData };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(receiptActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(RunReceiptsList);
